import axios from "axios";
import { checkout } from "../../models/checkoutData";
import { ShopifyOrder } from "../../models/razorData";

import { getAPI, postAPI, getAPIV2 } from "../remote/api_provider";

export const createCheckout = async (VCart: string, id: number) => {
  let response: checkout;

  response = await getAPI(VCart, id);
  const { data } = response || {};
  //   console.log(cart != null ? cart[0] : "")
  return data;
};

// v2 
export const createCheckoutV2 = async (VCart: string) => {
  let response: checkout;

  response = await getAPIV2(VCart);
  const { data } = response || {};
  //   console.log(cart != null ? cart[0] : "")
  return data;
};

// post api
export const createOrder = async (VCart: string, payload: number | any) => {
  let response: ShopifyOrder | any;

  response = await postAPI(VCart, payload);
  const { data } = response || {};
  return data;
};

// to get Checkout
export const fetchCheckout = async (VCart: string, payload: any) => {
  let response: any | checkout;
  response = await postAPI(VCart, payload);
  // const { data } = response || {};
  // return data;
  if (response.status === true) {
    const { data } = response || {};
    return data;
  } else {
    return response;
  }
};
